<ng-container [class.disabled]="disabled">
  <ng-content></ng-content>
</ng-container>
